/**
 * Validates a URL is safe to use in a navigation sink such as
 * `window.location.href`. Allows only http(s) schemes, blocks
 * `javascript:`, `data:`, `vbscript:`, and any malformed input.
 */
export const isSafeUrl = (value: unknown): value is string => {
  if (typeof value !== 'string' || value.length === 0) {
    return false;
  }
  if (value.startsWith('/') && !value.startsWith('//')) {
    return true;
  }
  try {
    const url = new URL(value);
    return url.protocol === 'http:' || url.protocol === 'https:';
  } catch {
    return false;
  }
};

/**
 * Performs a same-tab navigation to `value` only when it is a safe http(s)
 * URL. Returns `true` if navigation was performed.
 */
export const safeAssignLocation = (value: unknown): boolean => {
  if (!isSafeUrl(value)) {
    return false;
  }
  window.location.href = value;
  return true;
};
